import React, {useEffect, useState} from 'react';
import axios from "axios"
import DynamicNavBar from "../../Component/navbars/navbar";
import {IoIosAddCircleOutline} from "react-icons/io";
import apiRequests from "../../Component/axios/config/config";
import toast from "react-hot-toast";


export default function Package() {


    const [categories, setCategories] = useState([])

    const [loading, setLoading] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);

    const [addPackagesModal, setAddPackagesModal] = useState(false);

    const [selectedPackage, setSelectedPackage] = useState("");
    const [showModalDelete, setShowModalDelete] = useState(false);

    const [loadingaddBtn, setLoadingaddBtn] = useState(false);
    const [newPackage, setNewPackage] = useState({
        name: "",
        price: '',
        days: '',
        description: ""
    });

    const items = [
        {icon: <IoIosAddCircleOutline/>, label: "افزودن", func: () => setAddPackagesModal(true)},
    ]


    const apiLogin = () => {
        setLoading(true)
        apiRequests.get("/api/package/v1/get-all-packages",)
            .then((res) => {
                setCategories(res.data.data);
            })
            .catch((err) => {
            })
            .finally(() => {
                setLoading(false)
            })

    }

    useEffect(() => {
        apiLogin();
    }, []);


    const handleAddSubmit = () => {


        setLoadingaddBtn(true);
        apiRequests.post("/api/package/v1/create-package", newPackage)
            .then(() => {
                toast.success("دسته‌بندی با موفقیت افزوده شد.");
                closeAddModal()
                apiLogin();
            })
            .catch((error) => {
            })
            .finally(() => setLoadingaddBtn(false))
    }

    const closeAddModal = () => {
        setNewPackage({
            name: "",
            price: '',
            days: '',
            description: ""
        });
        setAddPackagesModal(false);
    }

    const handleDeleteClick = (item) => {
        setSelectedPackage(item);
        setShowModalDelete(true);
    };

    const confirmDelete = () => {
        if (!selectedPackage) return;
        setLoadingDelete(true);
        apiRequests.delete("/api/package/v1/delete-package", {
            data: { id: selectedPackage._id }
        })
            .then(() => {
                setShowModalDelete(false);
                setSelectedPackage(null);
                apiLogin();
                toast.success("کاربر با موفقیت حذف شد.")
            })
            .catch(() => { })
            .finally(() => setLoadingDelete(false));
    };


    return (

        <div>

            <div className="px-6 text-3xl ">
                پکیج ها
            </div>

            <div className="md:flex md:justify-center">
                <DynamicNavBar items={items}/>
            </div>

            <div className="flex justify-center mt-8">
                <table className="min-w-[80%]">
                    <thead
                        className="bg-secondColor-shade4 text-white text-center ">
                    <tr>
                        <th className="px-4 py-2 text-md md:text-[8px] font-medium rounded-tr-lg">نام</th>
                        <th className="px-4 py-2 text-md md:text-[8px] font-medium">قیمت</th>
                        <th className="px-4 py-2 text-md md:text-[8px] font-medium">روزها</th>
                        <th className="px-4 py-2 text-md md:text-[8px] font-medium">توضیحات</th>
                        <th className="px-4 py-2 text-md md:text-[8px] font-medium">وضعیت</th>
                        <th className="px-4 py-2 text-md md:text-[8px] font-medium rounded-tl-lg">عملیات</th>
                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                    {!loading ? (
                            categories.length > 0 ? (
                                categories.map((user, index) => (
                                    <tr key={index} className="hover:bg-gray-100 md:text-[8px] text-center">
                                        <td className="px-4 py-2">{user.name || "نام ثبت نشده"}</td>
                                        <td className="px-4 py-2">{user.price || "قیمت ثبت نشده"}</td>
                                        <td className="px-4 py-2">{user.days || "روزی ثبت نشده"}</td>
                                        <td className="px-4 py-2">{user.description || "توضیحی ثبت نشده"}</td>
                                        <td className="px-4 py-2">
                                            {!user.isDeleted ? (
                                                <span className="text-green-600 font-semibold">فعال</span>
                                            ) : (
                                                <span className="text-red-600 font-semibold">غیرفعال</span>
                                            )}
                                        </td>
                                        <td className="px-4 py-2 flex gap-3 justify-center">
                                            <button className="text-blue-600 hover:underline">ویرایش</button>
                                            /
                                            <button className="text-red-600 hover:underline" onClick={() => handleDeleteClick(user)}>حذف</button>

                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr className="hover:bg-gray-100 text-center">
                                    <td className="px-4 py-2" colSpan="6">
                                        دسته‌بندی‌ای یافت نشد!
                                    </td>
                                </tr>
                            )
                        )
                        :
                        <tr className="hover:bg-gray-100 text-center">
                            <td className="px-4 py-2" colSpan="6">
                                در حال بارگیری ...
                            </td>
                        </tr>
                    }
                    </tbody>
                </table>
            </div>

            {/* MODAL افزودن */}
            {addPackagesModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg">
                        <h2 className="text-xl font-bold mb-4 text-center">افزودن پکیج جدید</h2>
                        <input
                            type="text"
                            className="w-full border border-gray-300 rounded-md p-2 mb-4"
                            value={newPackage.name}
                            onChange={(e) => setNewPackage({...newPackage, name: e.target.value})}
                            placeholder="نام را وارد کنید"
                        />

                        <input
                            type="number"
                            className="w-full border border-gray-300 rounded-md p-2 mb-4"
                            value={newPackage.price}
                            onChange={(e) => setNewPackage({...newPackage, price: parseInt(e.target.value)})}
                            placeholder=" قمیت را وارد کنید"
                        />
                        <input
                            type="number"
                            className="w-full border border-gray-300 rounded-md p-2 mb-4"
                            value={newPackage.days}
                            onChange={(e) => setNewPackage({...newPackage, days: parseInt(e.target.value)})}
                            placeholder="تعداد روز را وارد کنید"
                        />
                        <input
                            type="text"
                            className="w-full border border-gray-300 rounded-md p-2 mb-4"
                            value={newPackage.description}
                            onChange={(e) => setNewPackage({...newPackage, description: e.target.value})}
                            placeholder="توضیحات"
                        />

                        <div className="flex justify-between">
                            <button
                                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                                onClick={handleAddSubmit}
                            >
                                {loadingaddBtn ?
                                    "در حال تایید ..."
                                    :
                                    "افزودن"
                                }
                            </button>
                            <button
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
                                onClick={closeAddModal}
                            >
                                لغو
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {showModalDelete && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 w-96 text-center shadow-lg">
                        <p className="mb-6">آیا می‌خواهید کاربر {selectedPackage?.name || "نامشخص"} را حذف کنید؟</p>
                        <div className="flex justify-around">
                            <button
                                onClick={confirmDelete}
                                className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700"
                            >
                                {loadingDelete ? "در حال حذف..." : "بله، حذف کن"}
                            </button>
                            <button
                                onClick={() => setShowModalDelete(false)}
                                className="bg-gray-300 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-400"
                            >
                                انصراف
                            </button>
                        </div>
                    </div>
                </div>
            )}


        </div>
    )

}